// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-upload@2.6.1@rc-upload/es/index.js
// module id = 927
// module chunks = 0 1